import { CSSelectOption } from "types";
import { SupportedLocales } from "consts";

type CSLocaleOption = CSSelectOption & {
  id: string;
};
type buildCommonLocaleOptionsReturn = CSLocaleOption[];

/**
 * TODO: This method be replaced by a common backend source
 */
const buildCommonLocaleOptions = (): buildCommonLocaleOptionsReturn => {
  return [
    {
      value: SupportedLocales.EN,
      text: "English",
      id: SupportedLocales.EN,
    },
    {
      value: SupportedLocales.ES,
      text: "Spanish",
      id: SupportedLocales.ES,
    },
  ];
};

export default buildCommonLocaleOptions;
